import { Box, Button, Grid, Typography } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { TextFieldSaurus } from 'views/components/controles/inputs';
import { DialogSaurus } from 'views/components/dialog/dialog-saurus/dialog-saurus';
import { OkIcon, VoltarIcon } from 'views/components/icons';
import { toDecimal } from 'utils/to-decimal';

interface DialogAplicarPercentualProps {
  aberto: boolean;
  onClose: () => void;
  onConfirm: (percentual: number) => void;
}

export const DialogAplicarPercentual = ({
  aberto,
  onClose,
  onConfirm,
}: DialogAplicarPercentualProps) => {
  const [percentual, setPercentual] = useState('');
  const [erro, setErro] = useState<string>();

  useEffect(() => {
    if (!aberto) return;
    setPercentual('');
    setErro(undefined);
  }, [aberto]);

  const confirmar = () => {
    if (percentual.trim() === '') {
      setErro('Informe o percentual.');
      return;
    }

    const valor = toDecimal(percentual, 4);
    if (Number.isNaN(valor) || valor < 0) {
      setErro('Informe um percentual válido.');
      return;
    }

    onConfirm(valor);
  };

  return (
    <DialogSaurus
      aberto={aberto}
      titulo="Aplicar % em Cima"
      tamanho="sm"
      isButtonTitleClose
      handleClickClose={onClose}
    >
      <Box
        component="form"
        onSubmit={(event) => {
          event.preventDefault();
          event.stopPropagation();
          confirmar();
        }}
        display="flex"
        flexDirection="column"
        gridGap={16}
        pb={1}
      >
        <Typography variant="body2" color="textSecondary">
          O percentual será aplicado sobre o valor de custo de todos os módulos. O adicional (%) ficará igual ao adicional de custo.
        </Typography>
        <TextFieldSaurus
          autoFocus
          allowSubmit
          tipo="DECIMAL"
          label="Percentual (%)"
          casasDecimais={4}
          manterMascara
          positivo
          limite={14}
          value={percentual}
          onChange={(event) => {
            setPercentual(event.target.value);
            setErro(undefined);
          }}
          error={Boolean(erro)}
          helperText={erro}
        />
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Button variant="outlined" color="primary" fullWidth type="button" onClick={onClose}>
              <VoltarIcon tipo="BUTTON" />
              Voltar
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button variant="contained" color="primary" fullWidth type="submit">
              <OkIcon tipo="BUTTON_PRIMARY" />
              Aplicar
            </Button>
          </Grid>
        </Grid>
      </Box>
    </DialogSaurus>
  );
};
